/**
 * Created by zhj on 3/25/2016.
 */
'use strict';

angular.module('dashboard.vehicleStatus', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('vehicleStatusWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.vehicleStatusWidget.title';
          },
          description: function () {
            return 'dashBoard.fleetManagement.vehicleStatusWidget.description';
          }
        },
        controller: 'vehicleStatusCtrl',
        templateUrl: 'components/dashboard/vehicleStatus/vehicleStatusWidget.tpl.html',
        isSingleInstance: true,
        config: {
          statusCodeList: [],
          vehicleList: [],
          vehicleGroup: null,
          vehicleGroupList: [],
          statusCode: null,
          noOfGridRows: ''
        }
      });
  }).service('vehicleStatusService', function (crudService, $filter) {

  this.getPendingCommand = function (deviceId) {
    var pendingCommandParams = {
      deviceID: deviceId,
      commandType: 'FNG',
      sendState: 0,
      commandArgs: ''
    };

    return pendingCommandParams;
  };

  this.getPendingCommandArgs = function (orderid, stateDesc) {
    var commandArgs = {
      date: $filter('date')(new Date(), 'yyyyMMdd'),
      time: $filter('date')(new Date(), 'HHmmss'),
      orderid: orderid || 0,
      status: typeof stateDesc === 'number' ? stateDesc : this.convertStateDescToStateNo(stateDesc) || null
    };
    return commandArgs;
  };

  this.convertStateDescToStateNo = function (stateDesc) {
    switch (stateDesc) {
      case 'pauseBegin':
        return 12;  // as described in Enterprise GTS (Data.BETONPLAN_PAUSE)
      case 'pauseEnd':
        return 14;  // as described in Enterprise GTS (DATA.BETONPLAN_PAUSE_END)
      case 'maintenanceBegin':
        return 13; // as described in Enterprise GTS (Data.BETONPLAN_INSERVICE)
      case 'maintenanceEnd':
        return 15;  // as described in Enterprise GTS (Data.BETONPLAN_INSERVICE_END)
      case 'login':
        return 9;   // as described in Enterprise GTS (Data.BETONPLAN_LOGIN)
      case 'logout':
        return 10;  // as described in Enterprise GTS (Data.BETONPLAN_LOGOUT)
    }
  };

  this.convertGtsStatusCodeToBetoplanCode = function (GTSstatusCode) {
    switch (GTSstatusCode) {
      case 61831:
        return 1;
      case 4097:
        return 2;
      case  62005:
        return 3;
      case  61973:
        return 4;
      case 4101:
        return 5;
      case 4102:
        return 6;
      case  4103:
        return 7;
      case 4104:
        return 8;
      case 63505:
        return 9;
      case 63506:
        return 10;
      case 4107:
        return 12;
      case  4109:
        return 13;
      case 4110:
        return 14;
      case 4111:
        return 15;
      default :
        return null;
    }
  };
  this.savePendingCommand = function (params) {
    return crudService.post('portalcommands/vehiclestatus', params);
  };

}).controller('vehicleStatusCtrl', function ($scope, $uibModal, $rootScope, vehicleStatusService, $translate, toastService) {
  $scope.vehicleStatus = {
    deviceID: '',
    order: ''
  };
  $scope.alerts = [];
  var selectedRow;
  var functionalProperties = {
    truckmixerFree: ['pauseBegin', 'maintenanceBegin', 'login', 'logout'],
    truckmixerReturnPlant: ['vehicleState', 'pauseBegin', 'maintenanceBegin'],
    truckmixerBusy: ['vehicleState', 'pauseBegin', 'maintenanceBegin'],
    truckmixerPause: ['pauseEnd'],
    truckmixerMaintenance: ['maintenanceEnd'],
    buttonNames: ['vehicleStateDisabled', 'retourDisabled', 'pauseBeginDisabled', 'maintenanceBeginDisabled', 'loginDisabled', 'orderDisabled', 'plantDisabled', 'pauseEndDisabled', 'maintenanceEndDisabled', 'logoutDisabled']
  };

  var disableButtons = function () {
    for (var i = 0; i < functionalProperties.buttonNames.length; i++) {
      $scope[functionalProperties.buttonNames[i]] = true;
    }
  };


  function activeButton(description) {
    var keys = _.keys(functionalProperties);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var lowerCaseKey = key.toLowerCase();
      if (lowerCaseKey.indexOf(description) !== -1) {
        for (var j = 0; j < functionalProperties[key].length; j++) {
          $scope[functionalProperties[key][j] + 'Disabled'] = false;
        }
      }
    }
  }

  var enableSupportedOperation = function (selectedRow) {
    disableButtons();
    var statusCode = selectedRow.jobstatuscode;
    var description;
    switch (statusCode) {
      case 63505:
      case 63506:
      case 4104:
        description = 'free';
        break;
      case 4103:
        description = 'returnplant';
        break;
      case 4097:
      case 61831:
      case 62005:
      case 61973:
      case 4101:
      case 4102:
        description = 'busy';
        break;
      case 4107:
        description = 'pause';
        break;
      case 4109:
        description = 'maintenance';
        break;
    }
    if (description) {
      activeButton(description);
    }
  };

  var openDialogOfTruckMixer = function (state) {
    if (state === 'pauseBegin' || state === 'vehicleState') {
      var dialogModel = {
        deviceID: $scope.vehicleStatus.deviceID,
        stateName: state
      };
      var modalInstance = $uibModal.open({
        templateUrl: 'components/dashboard/vehicleStatus/vehicleStatusDialog.tpl.html',
        controller: 'VehicleStatusDialogCtrl',
        resolve: {
          items: function () {
            return dialogModel;
          }
        }
      });

      modalInstance.result.then(function () {
      });
    }
  };
  $scope.vehicleStatusDialog = function (state) {
    openDialogOfTruckMixer(state);
  };

  $scope.updateVehicleState = function (statusDesc) {
    var pendingCommandParams = vehicleStatusService.getPendingCommand($scope.vehicleStatus.deviceID);
    var object = vehicleStatusService.getPendingCommandArgs(selectedRow.orderid, statusDesc);
    pendingCommandParams = _.extend(pendingCommandParams, object);
    return vehicleStatusService.savePendingCommand(pendingCommandParams).then(function () {
      toastService.showSuccessToast($translate.instant('vehicleStatus.operationSuccess'));
      $rootScope.$broadcast('portalCommandSaved');
    }, function () {
    });
  };

  $scope.buttonGroups = [
    {
      buttons: [{
        name: 'vehicleStatus.button.setvehicleState',
        state: 'vehicleState',
        visibility: 'vehicleStateDisabled',
        operation: $scope.vehicleStatusDialog,
        operationParam: 'vehicleState',
        isOpenModal: true
      }, {
        name: 'vehicleStatus.button.pauseBegin',
        state: 'pauseBegin',
        visibility: 'pauseBeginDisabled',
        operation: $scope.vehicleStatusDialog,
        operationParam: 'pauseBegin',
        isOpenModal: true
      }, {
        name: 'vehicleStatus.button.maintenanceBegin',
        state: 'maintenanceBegin',
        visibility: 'maintenanceBeginDisabled',
        operation: $scope.updateVehicleState,
        operationParam: 'maintenanceBegin',
        isOpenModal: false
      }, {
        name: 'vehicleStatus.button.login',
        state: 'login',
        visibility: 'loginDisabled',
        operation: $scope.updateVehicleState,
        operationParam: 'login',
        isOpenModal: false
      }]
    },
    {
      buttons: [{
        name: 'vehicleStatus.button.order',
        state: 'order',
        visibility: 'orderDisabled',
        operation: $scope.vehicleStatusDialog,
        operationParam: '',
        isOpenModal: true
      }, {
        name: 'vehicleStatus.button.pauseEnd',
        state: 'pauseEnd',
        visibility: 'pauseEndDisabled',
        operation: $scope.updateVehicleState,
        operationParam: 'pauseEnd',
        isOpenModal: false
      }, {
        name: 'vehicleStatus.button.maintenanceEnd',
        state: 'maintenanceEnd',
        visibility: 'maintenanceEndDisabled',
        operation: $scope.updateVehicleState,
        operationParam: 'maintenanceEnd',
        isOpenModal: false
      }, {
        name: 'vehicleStatus.button.logout',
        state: 'logout',
        visibility: 'logoutDisabled',
        operation: $scope.updateVehicleState,
        operationParam: 'logout',
        isOpenModal: false
      }]
    }
  ];


  $scope.$on('vehiclesListRowSelected', function (event, args) {
    if (args) {
      var broadcastEventData = args;
      selectedRow = broadcastEventData.selectedRow;
      if (!selectedRow) {
        $scope.isDataAvailable = false;
        return;
      }
      $scope.isDataAvailable = true;
      $scope.vehicleStatus.deviceID = selectedRow.deviceid;
      if (selectedRow.workorderjobdate && selectedRow.workorderjoblocation && selectedRow.workorderjobnumber) {
        $scope.vehicleStatus.order = selectedRow.workorderjobdate + '/' + selectedRow.workorderjoblocation + '/' + selectedRow.workorderjobnumber + '/';
      }
      enableSupportedOperation(selectedRow);
    } else {
      $scope.isDataAvailable = false;
    }
  });
  $scope.closeAlertByIndex = function (index) {
    $scope.alerts.splice(index, 1);
  };

});




// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicleStatus/vehicleStatusWidget.js